/*
 * [NWF] Passendes Zubehör on machine product pages (NWF-212).
 *
 * Loads the first page of the finder results for the product's machine model (and its series),
 * merges them by handle, and fills the product slider with the first `limit` cards. The slider
 * markup lives in a <template> and is only inserted once the cards exist, so product-slider
 * initialises with the right item count. Nothing found: the section stays hidden.
 */
(() => {
    const fetchPage = async (root, name, value) => {
        const url = new URL(root.dataset.resultsUrl, window.location.origin);
        url.searchParams.set(name, value);
        url.searchParams.set('section_id', root.dataset.resultsSection);
        const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`model accessories: ${response.status}`);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        return {
            total: Number(doc.querySelector('[data-finder-page]')?.dataset.total || 0),
            items: [...doc.querySelectorAll('[data-finder-item]')],
        };
    };

    const load = async (root) => {
        const filters = [['filter.p.m.nwf.compatible_models', root.dataset.modelId]];
        if (root.dataset.seriesId) filters.push(['filter.p.m.nwf.compatible_series', root.dataset.seriesId]);
        let pages;
        try {
            pages = await Promise.all(filters.map(([name, value]) => fetchPage(root, name, value)));
        } catch {
            return; /* the hand picked accessories slider still shows */
        }
        const seen = new Set();
        const items = [];
        for (const page of pages)
            for (const item of page.items)
                if (!seen.has(item.dataset.handle)) {
                    seen.add(item.dataset.handle);
                    items.push(item);
                }
        if (!items.length) return;

        const limit = Number(root.dataset.limit) || 10;
        const shown = items.slice(0, limit);
        const slider = root.querySelector('template[data-slider]').content.firstElementChild.cloneNode(true);
        slider.dataset.totalItems = String(shown.length);
        const grid = slider.querySelector('.products-grid');
        for (const item of shown) {
            item.classList.add('swiper-slide');
            grid.append(item);
        }
        root.append(slider);

        /* One list: the count is exact; merged lists: keep the plain link text. */
        const link = root.querySelector('.section__header--buttons a');
        if (link && pages.length === 1 && pages[0].total > shown.length)
            link.textContent = root.dataset.linkAll.replace('%d', String(pages[0].total));
        root.hidden = false;
    };

    const init = () => {
        document.querySelectorAll('[data-nwf-model-accessories]').forEach((root) => {
            if (root.dataset.ready) return;
            root.dataset.ready = 'true';
            load(root);
        });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
})();
